import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { t } from '../../../../services/i18nService';
import IdVerificationStartButton from './IdVerificationStartButton';
import idVerificationService from '../../../../services/idverification/IdVerificationService';

const IdVerificationStart = ({ buttonLabel, shouldShowRetakePhotoWithoutIdMessage }) => {
    return (
        <div>
            { shouldShowRetakePhotoWithoutIdMessage &&
                <p>{t('idVerification.overview.retakePhotoWithoutId')}</p>
            }

            <IdVerificationStartButton label={buttonLabel} />
        </div>
    );
};

IdVerificationStart.propTypes = {
    buttonLabel: PropTypes.string.isRequired,
    shouldShowRetakePhotoWithoutIdMessage: PropTypes.bool.isRequired,
};

const computeProps = () => {
    return {
        shouldShowRetakePhotoWithoutIdMessage: !idVerificationService.needsIdCard(),
        buttonLabel: t('idVerification.overview.start'),
    };
};

const IdVerificationStartContent = () => {
    return <IdVerificationStart {...computeProps()} />;
};

export default memo(IdVerificationStartContent);
